/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { BasicFormState } from 'hooks/useForm';
import { AssignmentField } from './types';

const useEstimatedStopOverTimes = (state: BasicFormState<AssignmentField>) => {
  const estimatedStopOverStartTime = useMemo(() => {
    if (
      state[AssignmentField.estimatedStartTime] &&
      state[AssignmentField.estimatedDuration]
    ) {
      const estimatedStartTime = new Date(
        state[AssignmentField.estimatedStartTime]
      );
      const estimatedDuration = Number(
        state[AssignmentField.estimatedDuration]
      );
      const result = new Date(estimatedStartTime.getTime() + estimatedDuration);
      return result;
    }
    return null;
  }, [
    state[AssignmentField.estimatedStartTime],
    state[AssignmentField.stopOverEstimatedDuration],
    state[AssignmentField.estimatedDuration],
  ]);

  const estimatedStopOverEndTime = useMemo(() => {
    // if we have a estimatedStopOverStartTime and a stopOverEstimatedDuration, calculate the end time
    if (
      estimatedStopOverStartTime &&
      state[AssignmentField.stopOverEstimatedDuration]
    ) {
      const stopOverEstimatedDuration = Number(
        state[AssignmentField.stopOverEstimatedDuration]
      );
      const result = new Date(
        estimatedStopOverStartTime.getTime() + stopOverEstimatedDuration
      );
      return result;
    }
    // if (
    //   state[AssignmentField.estimatedStartTime] &&
    //   state[AssignmentField.stopOverEstimatedDuration]
    // ) {
    //   const estimatedStartTime = new Date(
    //     state[AssignmentField.estimatedStartTime]
    //   );
    //   const stopOverEstimatedDuration = Number(
    //     state[AssignmentField.stopOverEstimatedDuration]
    //   );
    //   const result = new Date(
    //     estimatedStartTime.getTime() + stopOverEstimatedDuration
    //   );
    //   return result;
    // }
    return null;
  }, [
    state[AssignmentField.estimatedStartTime],
    state[AssignmentField.stopOverEstimatedDuration],
    state[AssignmentField.estimatedDuration],
  ]);

  const esimatedFinalEndTime = useMemo(() => {
    if (
      state[AssignmentField.estimatedStartTime] &&
      state[AssignmentField.estimatedDuration]
    ) {
      const estimatedStartTime = new Date(
        state[AssignmentField.estimatedStartTime]
      );
      const estimatedDuration = Number(
        state[AssignmentField.estimatedDuration]
      );
      const result = new Date(estimatedStartTime.getTime() + estimatedDuration);
      if (state[AssignmentField.stopOverEstimatedDuration]) {
        const stopOverEstimatedDuration = Number(
          state[AssignmentField.stopOverEstimatedDuration]
        );
        return new Date(result.getTime() + stopOverEstimatedDuration);
      }
      return result;
    }
    return null;
  }, [
    state[AssignmentField.estimatedStartTime],
    state[AssignmentField.estimatedDuration],
    state[AssignmentField.stopOverEstimatedDuration],
  ]);

  return {
    esimatedFinalEndTime,
    estimatedStopOverStartTime,
    estimatedStopOverEndTime,
  };
};

export default useEstimatedStopOverTimes;
